export default __webpack_public_path__ + "static/premagic-web-square-c8789f70ba8a615207f68ce2cead0d55.png";